/**
 * Helpers internes PARTAGÉS par plusieurs sous-modules de `layout/`
 * (`cx`, tables de classes réutilisées par size + container, template de
 * pistes réutilisé par columns + grid). NON ré-exportés par le barrel
 * `index.ts` : ils ne faisaient pas partie de la surface publique d'origine
 * et restent réservés aux imports inter-modules.
 */

import type { LayoutAlign } from "./types";

function cx(...parts: (string | false | null | undefined)[]): string {
  return parts.filter(Boolean).join(" ");
}

const ALIGN_CLASS: Record<LayoutAlign, string> = {
  start: "items-start",
  center: "items-center",
  end: "items-end",
  stretch: "items-stretch",
};

// Record large (string) pour tolérer les anciennes valeurs stockées (none/wide/2xl).
const MAX_WIDTH_CLASS: Record<string, string> = {
  full: "",
  prose: "mx-auto max-w-3xl",
  "1024": "mx-auto max-w-[1024px]",
  "1280": "mx-auto max-w-[1280px]",
  "1320": "mx-auto max-w-[1320px]",
  "1440": "mx-auto max-w-[1440px]",
  "1536": "mx-auto max-w-[1536px]",
  // Rétro-compat (anciennes valeurs) :
  none: "",
  wide: "mx-auto max-w-6xl",
  // Écrit par les premiers seeds de shell (= max-w-screen-2xl de l'ancien header).
  "2xl": "mx-auto max-w-[1536px]",
};

function columnTracksTemplate(sizes: string[]): string {
  return sizes.join(" ");
}

export { cx, ALIGN_CLASS, MAX_WIDTH_CLASS, columnTracksTemplate };
